<template>
    <nav :class='["page-nav", isColor ? "page-nav-black" : ""]'  ref="pageHead"  >
        <div class="nav-wrap clearfix">
            <div class="menu">
                <router-link to="/" class="brand"></router-link>
            </div>
            <div class="operaton">
                <ul class="clearfix">
                    <li class="resolve">
                        <a href="javascript:void(0)">Products
                            <i class="icon-down"></i>
                        </a>
                        <div class="selec-det resolve-det clearfix">
                            <div class="selec-con clearfix">
                                <router-link class="alpha" to="/en/Alpha">Alpha</router-link>
                                <router-link class="Beacons" to="/en/Beacons">Beacons</router-link>
                            </div>
                        </div>
                    </li>
                    <li>
                        <router-link to="/en/application">Scenarios</router-link>
                    </li>
                    <li class="news">
                        <a href="javascript:void(0)">Insights
                            <i class="icon-down"></i>
                        </a>
                        <div class="selec-det news-det clearfix">
                            <div class="selec-con clearfix">
                                <router-link class="news-core" to="/en/case">Case Studies</router-link>
                                <router-link class="events" to="/en/newsList">Media</router-link>
                            </div>
                        </div>
                    </li>
                    <li>
                        <router-link to="/en/about">About</router-link>
                    </li>
                    <li>
                        <router-link to="/en/contact">Contact</router-link>
                    </li>
                    <li>
                        <router-link to="/en/order">Order</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
    export default {
        // name: 'head',
        pops:['navActive'],
        data(){
            return{
                isColor: false,
                paths:['/en/order', '/en/newsList','/en/purchaseTerms','/en/developer']
            }
        },
        created() {
            this.isColor=this.paths.indexOf(this.$route.path)>-1
        },
        mounted() {},
        watch: {
            $route(to, from) {
                // const paths = ['/en/order', '/en/newsList','/en/purchaseTerms','/en/developer'];
                this.isColor = this.paths.indexOf(to.fullPath) > -1 || to.fullPath.indexOf('news') > -1||to.fullPath.indexOf('developer') > -1;

            }
        },
        methods: {

        }
    }
</script>

<style scoped lang="less">
    @baseWidth:1640px;
    .page-nav {
        white-space: nowrap;
        width: 100%;
        height: 65px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 10;
        transition: background .3s ease;
        &:hover {
            width: 100%;
            background: #fff;
            border-bottom: 1px solid #c3c6cb;
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
            .nav-wrap {
                a {
                    color: #000;
                }
                .icon-down {
                    width: 16px;
                    height: 16px;
                    margin-left: 5px;
                    background: url("/static/image/common/nav-iconB@2x.png") no-repeat center;
                    background-size: cover;
                }
                .menu .brand {
                    text-align: center;
                    vertical-align: middle;
                    background: url('/static/image/common/logo_navhover@2x.png') no-repeat;
                    background-size: cover;
                }
            }
        }

        a {
            color: #fff;
            font-size: 16px;
        }
        .nav-wrap {
            height: 100%;
            width: @baseWidth;
            margin: 0 auto;
            line-height: 65px;
            transition: background .3s ease;
            .menu {
                text-align: center;
                line-height: 65px;
                float: left;
                width: 115px;
                height: 100%;
                .brand {
                    display: inline-block;
                    width: 100%;
                    height: 22px;
                    text-align: center;
                    vertical-align: middle;
                    background: url('/static/image/common/logo_nav@2x.png') no-repeat center ;
                    background-size: cover;
                }
            }
        }
    }

    .operaton {
        float: right;
        padding-right: 10px;
        /*font-weight: bold;*/
        ul {
            display: flex;
            margin-left: -68px;
            li {
                height: 65px;
                /*display: flex;*/
                /*flex: 1;*/
                /*align-items: center;*/
                /*justify-items: center;*/
                float: left;
                padding: 0 5px;
                margin-left: 68px;
                border-bottom: 1px solid transparent;
                &:hover {
                    border-bottom: 1px solid #464749;
                }
                .icon-down {
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                    vertical-align: middle;
                    margin-left: 5px;
                    background: url('/static/image/common/nav_down@2x.png') no-repeat;
                    background-size: 100%;
                }
            }
        }
        .selec-det {
            display: none;
            position: absolute;
            top: 65px;
            left: 0;
            width: 108px;
            background: transparent;
            padding-top: 15px;
            overflow: hidden;
            text-align: center;
            margin: 0 auto;
            z-index: 15;
            box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.05);
            a {
                display: block;
                width: 100%;
                height: 50px;
                color: #5D5D5D;
                line-height: 50px;
                text-align: center;
                font-size: 14px;
            }
            .selec-con {
                background: #fff;
                margin: 0 auto;
                a:hover {
                    background: #ededed;
                }
            }
        }
        .news-det {
            width: 98px;
            .selec-con {
                width: 100%;
            }
        }
        ul li.resolve, ul li.news {
            position: relative;
        }
        ul li.resolve:hover .resolve-det {
            display: block;
        }
        ul li.news:hover .news-det {
            display: block;
        }
        .flexbox .nav-wrap {

            & > * {
                display: flex;
                align-items: stretch;
            }
            a {
                display: inline-flex;
                align-items: center;
            }
        }
    }
    .page-nav-black {
        .operaton {
            a {
                color: #000;
            }
            ul li .icon-down {
                display: inline-block;
                width: 16px;
                height: 16px;
                background: url("/static/image/common/nav-iconB@2x.png") no-repeat center;
                background-size: 100%;
            }
        }
        .nav-wrap .menu .brand {
            width:115px;
            height: 22px;
            background: url('/static/image/common/logo_navhover@2x.png') no-repeat center;
            background-size: cover;
        }
    }

    @media screen and (max-width: 1680px){
        @baseWidth:1216px;
        @autoWidth:1256px;
        .page-nav {
            width: 100%;
            min-width: @autoWidth;
            .nav-wrap {
                width: @baseWidth;

            }
        }
    }


</style>



// WEBPACK FOOTER //
// src/common/headTop.vue